module.exports = __webpack_public_path__ + "static/media/34DSS10.71a60151.jpg";